<template>
    <div>
        <div class="tiles tiles--grid-4">
            <ResultListItem
                    v-for="result in results" :key="result.href"
                    :title="result.title"
                    :category="result.category"
                    :href="result.href"
                    :image="result.image"
                    :typeSlug="slug"
            />
        </div>
    </div>

</template>
<script>
import ResultListItem from './ResultListItem'

export default {
    name: "ResultList",
    props: {
        results: Array,
        slug: String
    },
    components: {
        ResultListItem,
    },
    setup() {
    }
}
</script>